module.exports = __webpack_public_path__ + "img/charactor_02.b505aab2.png";